export enum UserRoles {
  ROLE_SUPERADMIN = 'ROLE_SUPERADMIN',
  ROLE_EMPLOYEE = 'ROLE_EMPLOYEE',
}

export enum UserNextAction {
  VERIFY_EMAIL = 'verify_email',
}
